import { apiSlice } from './apiSlice';

interface GetProductProvidersParams {
  accountId: string;
}

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductProviders: builder.query({
      query: ({ accountId }: GetProductProvidersParams) => ({
        url: `/product-providers?account_id=${accountId}`,
        method: 'get',
      }),
    }),
    updateAmazonProductProvider: builder.mutation({
      query: ({
        productProviderId,
        accountId,
        data,
      }: {
        productProviderId: string;
        accountId: string;
        data: { accountType: string };
      }) => ({
        url: `/product-providers/${productProviderId}`,
        params: { account_id: accountId },
        method: 'put',
        data,
      }),
    }),
    triggerSmidUpdate: builder.mutation({
      query: ({ productProviderId }: { productProviderId: string }) => ({
        url: `/product-providers/${productProviderId}/trigger-smid-update`,
        method: 'post',
      }),
    }),
  }),
});

export const {
  useGetProductProvidersQuery,
  useLazyGetProductProvidersQuery,
  useUpdateAmazonProductProviderMutation,
  useTriggerSmidUpdateMutation,
} = extendedApiSlice;
